<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>运营工具</el-breadcrumb-item>
      <el-breadcrumb-item>发货单转设备表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <!-- <p class="bold">上传发货单</p> -->
      <div
        class="exchange-container"
        v-loading="fullscreenLoading"
        element-loading-text="上传转换中"
      >
        <el-upload
          drag
          :action="uploadUrl"
          :data="formData"
          accept=".xlsx"
          :headers="uploadHeader"
          :show-file-list="false"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
          :before-upload="beforeUpload"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将发货单拖到此处，或<em>点击上传</em>
          </div>
        </el-upload>
      </div>
    </div>
  </div>
</template>

<script>
import { host, urlPerfix } from '@/config/env'
import store from '@/store/store'

export default {
  data() {
    return {
      fullscreenLoading: false,
      uploadUrl: urlPerfix + '/files/import',
      uploadHeader: { Token: store.state.userInfo.token },
      formData: {
        obj: 'delivery_to_device',
      },
    }
  },
  methods: {
    handleUploadSuccess(res, file) {
      if (res.code != 0) {
        this.$alert('导入失败，请刷新页面重试')
      } else {
        let href = res.data + `?v=${Math.random()}`
        window.location.href = href
      }
      this.fullscreenLoading = false
    },
    beforeUpload() {
      this.fullscreenLoading = true
    },

    handleUploadError(err) {
      this.$message({
        message: '上传失败，请重试',
        type: 'error',
        center: true,
      })
    },
  },
}
</script>

<style scoped>
.exchange-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 200px);
}
</style>